var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"height":_vm.imgHeight,"src":_vm.getIcon()}})}
var staticRenderFns = []

export { render, staticRenderFns }